import {buttonVariants, Icon, Link} from '@ezcater/tapas';
import {faCartCircleXmark} from '@fortawesome/pro-light-svg-icons';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';

import useAuthReturnDestination from '@/hooks/useAuthReturnDestination';
import useIdentity from '@/hooks/useIdentity';
import {SIGN_IN_PATH} from '@/paths';

type EmptyStateContentProps = {
  text: React.ReactNode;
  buttonText?: React.ReactNode;
  path?: string;
};

const EmptyStateContent: React.FC<EmptyStateContentProps> = ({text, buttonText, path}) => (
  <div className="align-center flex flex-col py-2 text-center">
    <Icon size="xlarge" icon={faCartCircleXmark} className="mb-4 self-center text-6xl" />
    <div>{text}</div>

    {buttonText && (
      <Link
        className={buttonVariants({
          className: 'mt-4 w-24 self-center no-underline',
          size: 'medium',
          variant: 'primary',
        })}
        href={path}
      >
        {buttonText}
      </Link>
    )}
  </div>
);

const EmptyState: React.FC = () => {
  const {t} = useTranslation('app-bar');
  const {data} = useIdentity();
  const {authPath} = useAuthReturnDestination();
  const loginPath = authPath(SIGN_IN_PATH);
  const isLoggedIn = !!data?.me?.consumerAccount;

  return (
    <div>
      {isLoggedIn ? (
        <EmptyStateContent
          text={<Trans i18nKey="app-bar:cart.empty.label" components={{br: <br />}} />}
        />
      ) : (
        <EmptyStateContent
          text={<Trans i18nKey="app-bar:cart.empty.label" components={{br: <br />}} />}
          buttonText={t('navLinks.signIn')}
          path={loginPath}
        />
      )}
    </div>
  );
};

export default EmptyState;
